import { useSelector } from 'react-redux';
import DataTableGrid from '../../../../components/common/DataTableGrid';
import ExportTable from '../../../../components/common/export-table/ExportTable';
import './overall-stats.scss';
import { selectRunLifeOverallStats } from '../../RunlifeDarshboardSlice';
import { formatNumber } from '../../../../utilities/Helpers';

export const runLifeOverallStats = [
  { key: 'TotalWells', title: 'Total wells' },
  { key: 'TotalInstallations', title: 'Total installations' },
  { key: 'TotalRunningUnits', title: 'Total running units' },
  { key: 'TotalFailures', title: 'Total failures' },
  { key: 'TotalFailuresWithinDays', title: 'Total failures < 90 days' },
  { key: 'TotalPulls', title: 'Total pulls (no failure)' },
  { key: 'AverageRunlife', title: 'Average runlife (days)' },
  { key: 'AverageRunlifeRunningUnits', title: 'Average runlife running (days)' },
  { key: 'AverageRunlifeFailedUnits', title: 'Average runlife failed (days)' },
  { key: 'AverageRunlifePulledUnits', title: 'Average runlife pulled no failure (days)' },
  { key: 'MeanTimeBetweenFailure', title: 'Mean time between failure (days)' },
  { key: 'TotalExcludedInstallations', title: 'Excluded installations' },
  //Direct ESP failure
  { key: '', title: 'Direct ESP failure' },
  { key: 'TotalDirectFailures', title: 'Total failures' },
  { key: 'TotalDirectFailuresWithinDays', title: 'Total failures < 90 days' },
  { key: 'AverageRunlifeDirectFailedUnits', title: 'Average runlife failed (days)' },
  //Indirect ESP failure (Tubing)
  { key: '', title: 'Indirect ESP failure (Tubing)' },
  { key: 'TotalTubingIndirectFailures', title: 'Total failures' },
  { key: 'TotalTubingIndirectFailuresWithinDays', title: 'Total failures < 90 days' },
  { key: 'AverageRunlifeFailedUnits', title: 'Average runlife failed (days)' },
  //Indirect ESP failure (Wellhead penetrator)
  { key: '', title: 'Indirect ESP failure (Wellhead penetrator)' },
  { key: 'N/A', title: 'Total failures' },
  { key: 'N/A', title: 'Total failures < 90 days' },
  { key: 'N/A', title: 'Average runlife failed (days)' },
  //Non ESP intervention
  { key: '', title: 'Non ESP intervention' },
  { key: 'TotalPullsNonIntervention', title: 'Total pulls (no failure)' },
  { key: 'AverageRunlifePulledNonInterventionUnits', title: 'Average runlife pulled no failure (days)' },
];
const columns = [
  {
    Header: 'Statistic',
    accessor: 'title',
    disableFilters: true,
    Cell: ({ value, row }: { value: any; row: any }) => {
      // Extra bold for section headers (key === '')
      if (row.original?.key === '') {
        return <span style={{ fontWeight: 800, fontSize: '15px' }}>{value}</span>;
      }
      return <span>{value}</span>;
    },
  },
  {
    Header: 'Total',
    accessor: 'count',
    disableFilters: true,
    Cell: ({ value, row }: { value: any; row: any }) => {
      // Empty for section headers (key === '')
      if (row.original?.key === '') {
        return <span></span>;
      }
      const num = parseFloat(formatNumber(value, 1));
      return <span>{isNaN(num) ? '-' : num}</span>;
    },
  },
];
const OverallStats: React.FC = () => {
  const data = useSelector(selectRunLifeOverallStats);

  const exportColumns = columns.map((col) => ({
    key: typeof col.accessor === 'string' ? col.accessor : '',
    header: typeof col.Header === 'string' ? col.Header : '',
    accessor: (row: any) => {
      const key = typeof col.accessor === 'string' ? col.accessor : '';
      if (key === 'count') {
        const value = row.original?.count;
        return value !== undefined && value !== null ? formatNumber(value, 1) : '';
      }
      return row.original?.[key] ?? '';
    },
  }));

  const tableRowsForExport = Array.isArray(data) ? data.map((item: any) => ({ original: item })) : [];

  const rPermission = { canExport: true };

  return (
    <div className='overall-stats-container'>
      <div className='overall-stats-header'>Overall statistics</div>
      <div className='wsw-divider' />
      <div className='runlife-export-button'>
        <ExportTable
          data={tableRowsForExport}
          fileName={'Overall Statistics'}
          sheetName={'Overall Stats'}
          columns={exportColumns}
          disabled={!tableRowsForExport || tableRowsForExport.length === 0}
          rPermission={rPermission}
        />
      </div>
      <div className='overall-stats-table-container'>
        <div className='table-scroll-wrapper'>
          <DataTableGrid data={data} columns={columns} maxHeight='100%' disableSort={true} />
        </div>
      </div>
    </div>
  );
};
export default OverallStats;
